import {ApolloClient, ApolloLink, HttpLink, InMemoryCache, split,} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import apolloLogger from "apollo-link-logger";
import getConfigByName from "../../../config";
import { createLog } from "../restful/logs/logs";

const authMiddleware = new ApolloLink((operation, forward) => {
    operation.setContext(({headers = {}}) => ({
        headers: {
            ...headers,
            authorization: "Bearer " + localStorage.getItem("a_t") || "",
        },
    }));

    // rides in the variables so no operation has to declare it, and nothing between the
    // browser and the server sees anything but an ordinary post body
    const trustedDeviceToken = localStorage.getItem("d_t");

    if (trustedDeviceToken) {
        operation.variables = {...operation.variables, trustedDeviceToken};
    }

    return forward(operation);
});

// const baseInstrumentLink = new HttpLink({ uri: getConfigByName().graphqlURL });
const marketBuzzLink = new HttpLink({uri: "https://marketbuzz.nextrades.ai/graphql"})
const baseLink = new HttpLink({uri: getConfigByName().graphqlURL});

const splitLink = split(
    (operation) => operation.variables.context?.endPoint === "marketBuzz",
    marketBuzzLink,
    baseLink
);

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
    const opName = operation.operationName || "Unknown";
    const opType = operation.query?.definitions?.[0]?.operation || "query";

    if (graphQLErrors) {
        createLog({
            status: "error",
            module: "System",
            submodule: "GraphQL",
            function: opName,
            description: `${opType} failed: ${graphQLErrors[0]?.message}`,
            logData: graphQLErrors.map((e) => ({
                message: e.message,
                errorCode: e.extensions?.code,
                path: e.path,
                locations: e.locations,
            })),
        });
    }
    if (networkError) {
        const errorCode = networkError.statusCode || networkError.code;
        createLog({
            status: "error",
            module: "System",
            submodule: "GraphQL",
            function: opName,
            description: `${opType} network error: ${networkError.message}`,
            logData: { message: networkError.message, errorCode, stack: networkError.stack },
        });
    }
});

export const client = new ApolloClient({
    cache: new InMemoryCache({
        typePolicies: {
            Query: {
                fields: {
                    merge(existing = [], incoming) {
                        return [...existing, ...incoming];
                    },
                },
            },
        },
    }),
    defaultOptions: {
        watchQuery: {
            fetchPolicy: "network-only",
        },
    },
    link: ApolloLink.from([authMiddleware, errorLink, apolloLogger, splitLink]),
});

export async function ApolloClientQuery(query, variables, isMutation = false, fetchPolicy) {
    const response = await client[isMutation ? "mutate" : "query"]({
        [isMutation ? "mutation" : "query"]: query,
        variables,
        ...(fetchPolicy ? {fetchPolicy} : {}),
    });

    return response?.data;
}
